
export interface Solution {
  id: string;
  title: string;
  agency: "GSA" | "Education" | "NOAA" | "Quebec" | "CURT" | "iSPAI";
  curator: string;
  commercialType: "Sale" | "Lease" | "Collaborate" | "Stake";
  category: string;
  basePrice: number;
  price: number;
  description: string;
  capturedDate?: string;
  contentType: "Private" | "Public";
}

export const AGENCIES = {
  GSA: "General Services Administration",
  Education: "Department of Education",
  NOAA: "National Oceanic and Atmospheric Administration",
  Quebec: "Government of Quebec",
  CURT: "Construction Users Roundtable",
  iSPAI: "Intelligent Strategic Public AI Initiative"
};

// Commercial type pricing factors
export const PRICE_FACTORS = {
  Sale: 0.25,    // 25% of base price (75% reduction)
  Lease: 0.0625, // 6.25% of base price (25% of new sale price)
  Collaborate: 0.2, // 20% of base price
  Stake: 0.05    // 5% of Composer Solution Bounty Value
};
